import { render, staticRenderFns } from "./Wormwood.vue?vue&type=template&id=daa9aa0c&"
import script from "./Wormwood.vue?vue&type=script&lang=js&"
export * from "./Wormwood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports